export default "__VITE_ASSET__CDni77S7__"